import { Filter } from './filter';

export class Clinic {
    name: string
    description: string
    url: string
    filters: Filter[]
    rank: number = 0

    constructor (name: string, description: string, url:string, filters: Filter[], rank:number){
        this.name = name;
        this.description = description;
        this.url = url;
        this.filters = filters;
        this.rank = rank;
    }
}